export default {"src":"/_next/static/media/profile-clip-1.e3b8e6dc.svg","height":122,"width":122,"blurWidth":0,"blurHeight":0};